import { Link } from 'react-router-dom'

const WHEEL_ROTATIONS = [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]

const FEATURE_CARDS = [
  {
    title: 'KUNDLI',
    subtitle: 'BIRTH CHART',
    path: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z',
  },
  {
    title: 'HOROSCOPE',
    subtitle: 'DAILY RASHIFAL',
    path: null,
    circle: true,
  },
  {
    title: 'REMEDIES',
    subtitle: 'UPAYA & PUJA',
    path: 'M12 2l3 6 6 1-4 4 1 6-6-3-6 3 1-6-4-4 6-1z',
  },
  {
    title: 'VASTU',
    subtitle: 'SPATIAL HARMONY',
    path: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  },
]

function scrollToAstrologers() {
  const el = document.getElementById('our-astrologers')
  if (el) window.scrollTo({ top: el.offsetTop - 120, behavior: 'smooth' })
}

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-svh lg:min-h-screen flex items-center justify-center overflow-hidden bg-[#120A05] pt-24 pb-16 lg:pt-32 lg:pb-24">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-linear-to-b from-[#1A0E06] via-[#160B05] to-[#0C0703]" />
        <div className="absolute inset-0 bg-[radial-gradient(60%_55%_at_75%_42%,rgba(232,119,15,0.18),transparent_70%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(48%_50%_at_12%_88%,rgba(122,31,43,0.28),transparent_70%)]" />
      </div>

      <div className="lg:hidden absolute inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className="w-[115vw] max-w-115 opacity-[0.25]">
          <div className="relative aspect-square w-full">
            <div className="absolute inset-0 animate-spin" style={{ animationDuration: '90s' }}>
              <svg viewBox="0 0 400 400" className="w-full h-full" fill="none">
                <circle cx="200" cy="200" r="196" stroke="#E6C878" strokeOpacity="0.55" strokeWidth="1" />
                {WHEEL_ROTATIONS.slice(0, 2).map((r) => (
                  <text key={r} x="200" y="51" textAnchor="middle" fontSize="20" fill="#F0D9A0" transform={`rotate(${r} 200 200)`}>
                    ✦
                  </text>
                ))}
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 container px-4 mx-auto grid lg:grid-cols-2 gap-8 lg:gap-6 items-center">
        <div className="space-y-4 sm:space-y-6 md:space-y-7 text-center lg:text-left flex flex-col items-center lg:items-start p-10 lg:p-5">
          <div className="flex items-center gap-3">
            <span className="text-xl text-secondary leading-none">ॐ</span>
            <span className="font-cinzel text-[11px] font-semibold text-[#E6C878] tracking-[0.28em] uppercase">
              ॥ Jyotish Consultation ॥
            </span>
          </div>

          <h1 className="font-cinzel text-[1.85rem] sm:text-3xl md:text-5xl lg:text-5xl xl:text-6xl leading-[1.08] uppercase font-normal text-[#FBF3E4]">
            DIRECT GUIDANCE FROM <br />
            <span className="text-gradient-gold">RAJU MAHARAJ JI</span>
          </h1>

          <p className="text-sm md:text-base text-white/65 max-w-xl leading-relaxed normal-case">
            Personalised Kundli analysis, life-path guidance, and authentic Vedic remedies — direct from Maharaj Ji
            over a private one-to-one session.
          </p>

          <div className="grid grid-cols-2 gap-2.5 sm:gap-4 w-full max-w-xl">
            {FEATURE_CARDS.map((card) => (
              <div
                key={card.title}
                className="group relative bg-white/[0.04] backdrop-blur-sm border border-white/10 p-2.5 sm:p-4 rounded-xl sm:rounded-2xl flex items-center gap-2.5 sm:gap-4 transition-all duration-300 hover:bg-white/[0.07] hover:border-[#E6C878]/40 overflow-hidden"
              >
                <div className="shrink-0 w-8 h-8 sm:w-11 sm:h-11 flex items-center justify-center bg-orange-500/[0.12] border border-orange-500/30 rounded-md sm:rounded-lg">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F2A007" strokeWidth="2">
                    {card.circle ? <circle cx="12" cy="12" r="4" /> : <path d={card.path} />}
                  </svg>
                </div>
                <div className="flex flex-col text-left">
                  <h4 className="text-[10px] sm:text-sm font-cinzel text-[#FBF3E4] uppercase">{card.title}</h4>
                  <p className="hidden sm:block text-[10px] text-[#E6C878]/55 uppercase">{card.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 pt-1">
            <Link
              to="/book-maharaj-ji"
              className="bg-[#E8770F] text-white px-8 h-12 rounded-full text-[11px] font-semibold uppercase tracking-[0.28em] shadow-lg transition-all hover:bg-orange-600 flex items-center"
            >
              Book Appointment
            </Link>
            <button
              type="button"
              onClick={scrollToAstrologers}
              className="border border-[#E6C878]/40 text-[#FBF3E4] px-8 h-12 rounded-full text-[11px] font-semibold uppercase tracking-[0.28em] flex items-center hover:bg-[#E6C878]/10 transition-all"
            >
              View Astrologers
            </button>
          </div>
        </div>

        <div className="relative hidden lg:flex items-center justify-center">
          <div className="absolute w-100 h-100 bg-[radial-gradient(circle,rgba(232,119,15,0.15),transparent_70%)] blur-3xl" />
          <div className="w-[min(460px,40vw)] relative">
            <div className="relative aspect-square w-full select-none" aria-hidden="true">
              <div className="absolute inset-[18%] rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.28),transparent_70%)] blur-2xl" />
              <div className="absolute inset-0 animate-[spin_90s_linear_infinite] motion-reduce:animate-none">
                <svg viewBox="0 0 400 400" className="w-full h-full" fill="none">
                  <circle cx="200" cy="200" r="196" stroke="#E6C878" strokeOpacity="0.55" strokeWidth="1" />
                  <circle cx="200" cy="200" r="168" stroke="#C99A2E" strokeOpacity="0.4" strokeWidth="1" />
                  <circle cx="200" cy="200" r="120" stroke="#C99A2E" strokeOpacity="0.3" strokeWidth="1" />
                  <circle cx="200" cy="200" r="58" stroke="#E8770F" strokeOpacity="0.5" strokeWidth="1" />
                  {WHEEL_ROTATIONS.slice(0, 6).map((r) => (
                    <line
                      key={r}
                      x1="200" y1="32" x2="200" y2="368"
                      stroke="#C99A2E" strokeOpacity="0.16" strokeWidth="1"
                      transform={`rotate(${r} 200 200)`}
                    />
                  ))}
                  {WHEEL_ROTATIONS.map((r) => (
                    <g key={r} transform={`rotate(${r} 200 200)`}>
                      <circle cx="200" cy="44" r="17" fill="#E8770F" fillOpacity="0.12" stroke="#E6C878" strokeOpacity="0.55" strokeWidth="1" />
                      <text x="200" y="51" textAnchor="middle" fontSize="20" fill="#F0D9A0">✦</text>
                    </g>
                  ))}
                </svg>
              </div>
              <div className="absolute inset-[30%] animate-[spin_60s_linear_infinite_reverse] motion-reduce:animate-none">
                <svg viewBox="0 0 200 200" className="w-full h-full" fill="none">
                  <circle cx="100" cy="100" r="96" stroke="#E6C878" strokeOpacity="0.25" strokeWidth="1" strokeDasharray="2 8" />
                </svg>
              </div>
              <div className="absolute inset-0 grid place-items-center">
                <span className="text-3xl md:text-4xl text-[#F0D9A0]" style={{ textShadow: 'rgba(232, 119, 15, 0.65) 0px 0px 22px' }}>
                  ॐ
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
